import script from "./DeviceMockup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeviceMockup.vue?vue&type=script&setup=true&lang=ts"

import "./DeviceMockup.vue?vue&type=style&index=0&id=06bce7fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bce7fb"]])

export default __exports__